<template>
  <div>
    <!-- 关联赔款单 -->
    <el-dialog :title="$t('message.relatedCompensationOrder')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="480px" center>
      <div class="content">
        <!-- 待退款数量 -->
        <div class="row">
          <el-radio v-model="radio" label="1">创建新赔款单</el-radio>
        </div>
        <div class="row">
          <div class="label"> <el-radio v-model="radio" label="2">已有赔款单</el-radio></div>
          <el-input v-model="reparation_sn"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 提交 -->
        <el-button type="primary" @click="save">
          {{ $t("message.submit") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    checkList: { type: Array }
  },
  data() {
    return {
      radio: '1',
      reparation_sn: '',
      dialogVisible: false,
    };
  },
  methods: {
    // 保存
    save() {
      // 已有赔款单
      if (this.radio == 2) {
        let datas = {
          ids: [],
          reparation_sn: this.reparation_sn,
        };
        this.checkList.forEach(item => {
          datas.ids.push(item.id)
        })
        if (!this.reparation_sn) return this.$message.error('请输入要关联的赔款单号')
        this.$api.inSaleApi.addReparation(datas).then((res) => {
          this.$message.success(res.msg);
          this.dialogVisible = false;
          this.$parent.inSaleList()
        });
      } else { //创建赔款单
        this.dialogVisible = false
        this.$parent.getNewReparationSn()
      }

    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;
    line-height: 40px;

    .label {
      line-height: 40px;
      margin-right: 20px;
    }

    .val {
      flex: 3;
    }
  }

}
</style>